<template>
  <div ref="vueRemove">
    <!-- Modal paymentsenseConencteModal -->
    <div class="modal fade text-black" ref="paymentsenseConencteModal" :id="$id('paymentsenseConencteModal')" data-backdrop="static" data-keyboard="false" tabindex="-1" :aria-labelledby="$id('payLabel')" aria-hidden="true">
      <div class="modal-dialog vld-parent" role="document" ref="paymentsenseConencteDialog" >
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title heading" :id="$id('payLabel')">{{ location.name }} Payment</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div v-if="timeLeftToPay && timeLeftToPay.asMinutes() < 60" class="mb-2">
              Please complete your payment in the next<br>
              <strong class="text-monospace">{{ timeLeftToPayFormatted }}</strong>
            </div>
            <div v-if="timeExpired" class="mb-2 text-red font-weight-bold">
              Sorry you did not complete your payment in time.
            </div>

            <div>
              Amount to pay: <strong v-if="amount">{{ amount | money }}</strong>
            </div>

            <div v-show="wallletButtonShow" ref="paymentRequestFG" class="form-group">
              <div ref="paymentRequestButton" :id="$id('wallet-div')">
                <!-- Wallet button will be inserted here. -->
              </div>
            </div>

            <div class="form-group">
              <div ref="cardDiv" :id="$id('card-div')" :class="['card-div', 'w-100', cardErrors ? 'is-invalid' : '']">
                <!-- A ConnectE iframe will be inserted here. -->
              </div>
              <template v-if="cardErrors" >
                <div v-for="(cardError, key) in cardErrors" class="invalid-feedback" role="alert" :key="key">{{ cardError.message }}</div>
              </template>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary btn-lg btn-block"
              :disabled="cardButtonDisable"
              @click="submitPayment">
              <i class="fas fa-credit-card" aria-hidden="true"></i> Submit Payment
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal paymentsenseConencteModal -->

    <!-- Success Modal -->
    <div
      class="modal fade text-black"
      ref="successModal"
      :id="$id('successModal')"
      tabindex="-1"
      :aria-labelledby="$id('successLabel')"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-weight-bold" :id="$id('successLabel')">{{ location.name }} Payment</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-black" style="color: black !important">{{ successMessage }}</p>
          </div>
          <div class="modal-footer">
            <p class="text-black" style="color: black !important">Page will reload in {{ reloadTime }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal end -->
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },

    paymentProviderPublicOptions: {
      type: [Array, Object],
      default: null,
    },
  },

  data() {
    return {
      sale: null,
      saleable: null,
      payingDeposit: false,

      connectE: null,
      wallet: null,
      wallletButtonShow: false,
      cardButtonDisable: true,
      walletButtonDisable: true,

      accessTokenId: null,
      accessTokenExpiresAt: null,
      paymentExpiry: null,
      amount: null,

      isLoading: true,
      loader: null,

      cardErrors: null,
      successMessage: 'Payment successful.',
      reloadTime: 2,

      currentTimeInterval: null,
      currentTime: moment(),
    };
  },

  computed: {
    payConfig() {
      return {
        paymentDetails: {
          amount: this.amount,
          currencyCode: this.paymentProviderPublicOptions.currencyCode,
          paymentToken: this.accessTokenId,
        },
        containerId: this.$id('card-div'),
        fontCss: ['https://fonts.bunny.net/css?family=montserrat:300,400,700'],
        styles: {
          base: {
            default: {
              // color: 'black',
              textDecoration: 'none',
              fontFamily: "Montserrat, sans-serif",
              boxSizing: 'border-box',
              // padding: '.375rem .75rem',
              boxShadow: 'none',
              // fontSize: '1rem',
              // borderRadius: '.25rem',
              // lineHeight: '1.5',
              // backgroundColor: '#fff',

              display: 'block',
              width: '100%',
              height: 'calc(1.5em + 0.75rem + 2px)',
              padding: '0.375rem 0.75rem',
              fontSize: '1rem',
              fontWeight: '400',
              lineHeight: '1.5',
              color: '#495057',
              backgroundColor: '#FEFEFE',
              backgroundClip: 'padding-box',
              border: '1px solid #ced4da',
              borderRadius: '0.25rem',
              transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
            },
            focus: {
              // color: '#495057',
              // borderColor: '#80bdff',
              color: '#495057',
              backgroundColor: '#FEFEFE',
              borderColor: '#80bdff',
              outline: '0',
              boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
            },
            error: {
              // color: '#B00',
              // borderColor: '#B00'
              borderColor: '#dc3545',
            },
            valid: {
              // color: 'green',
              // borderColor: 'green'
              borderColor: '#28b745',
            },
            label: {
              display: 'none'
            }
          },
          cv2: {
            container: {
              width: '50%',
              float: 'left',
              boxSizing: 'border-box'
            },
            default: {
              borderRadius: '0 .25rem .25rem 0'
            }
          },
          expiryDate: {
            container: {
              width: '50%',
              float: 'left',
              borderRadius: '.25rem 0 0 .25rem',
            },
            default: {
              borderRadius: '.25rem 0 0 .25rem',
              borderRight: 'none'
            },
          },
          cardNumber: {
            container: {
              width: '100%',
              float: 'left',
            },
            default: {
              borderRadius: '.25rem'
            },
          }
        }
      };
    },

    walletPayConfig() {
      return {
        paymentDetails: {
          amount: this.amount,
          currencyCode: this.paymentProviderPublicOptions.currencyCode,
          paymentToken: this.accessTokenId,
        },
        containerId: this.$id('wallet-div'),
        buttonConfig: {
            color: 'black',
            type: 'plain'
        },
        emailRequired: true,
        billingAddressRequired: false,
        shippingAddressRequired: false,
        // onIframeLoaded: null,
        // onIframeLoadFailed: null,
        callbacks: {
          onPaymentCancelled: this.walletOnPaymentCancelled,
          onPaymentInitiated: this.walletOnPaymentInitiated,
        }
      };
    },

    timeLeftToPay() {
      if (this.paymentExpiry == null) {
        return null;
      }

      let duration = moment.duration(moment(this.paymentExpiry).subtract(60, 'seconds').diff(this.currentTime));

      return duration;
    },

    timeLeftToPayFormatted() {
      if (this.timeLeftToPay == null) {
        return null;
      }
      if (this.timeLeftToPay < 0) {
        return "00 minutes 00 seconds";
      }

      return this.timeLeftToPay.format('mm [minutes] ss [seconds]', {
        trim: false
      });
    },

    timeExpired() {
      if (this.timeLeftToPay) {
        return this.timeLeftToPay < 0;
      }

      return false;
    },
  },

  watch: {
    sale(newSale, oldSale) {
      if (newSale) {
        this.createAccessToken();
      } else {
        this.accessTokenId = null;
        this.accessTokenExpiresAt = null;
        this.amount = null;
        // this.wallet.destroy();
        this.paymentRequest = null;
        this.wallletButtonShow = false;
        this.cardButtonDisable = true;
        this.payingDeposit = false;
      }
    },

    timeExpired(newTimeExpired) {
      if (newTimeExpired) {
        // disable buttons
        this.cardButtonDisable = true;
        this.walletButtonDisable = true;
        this.wallletButtonShow = false;
        this.$emit('payment-time-expired')
      } else {
        // enable buttons
        this.cardButtonDisable = false;
        this.walletButtonDisable = false;
      }
    },
  },

  methods: {
    /* ===============
     * public methods
     */

    takeSalePayment(sale, allowDepositFlag = false) {
      this.sale = sale;
      this.payingDeposit = allowDepositFlag;

      this.showPaymentsenseConencteModal();
    },

    takeBookingPayment(booking) {
      // console.log(booking);
      this.sale = booking.sale
      this.saleable = booking;

      this.showPaymentsenseConencteModal();

      // start expire timer
    },

    takeVoucherPayment(voucher) {
      this.sale = voucher.sale
      this.saleable = voucher;

      this.showPaymentsenseConencteModal();
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      this.sale = sale;
      this.saleable = virtualGame;

      this.showPaymentsenseConencteModal();
    },

    /*
     * END public methods
     * =============== */

    /* ===============
     * paymentsenseConencteModal methods
     */

    showPaymentsenseConencteModal() {
      // Do any prep before showing the modal

      $(this.$refs.paymentsenseConencteModal).modal('handleUpdate');
      $(this.$refs.paymentsenseConencteModal).modal('show');
    },

    hidePaymentsenseConencteModal() {
      $(this.$refs.paymentsenseConencteModal).modal('hide');
    },

    paymentsenseConencteModalShown() {
      // console.log('paymentsenseConencteModalShown');
    },

    paymentsenseConencteModalHidden() {
      // console.log('paymentsenseConencteModalHidden');
      this.sale = null;
      this.saleable = null;

      this.accessTokenId = null;
      this.accessTokenExpiresAt = null;
      this.amount = null;
      this.cardButtonDisable = true;
      // this.cardElement.clear();
      // this.wallet.destroy();
    },

    /*
     * END paymentsenseConencteModal methods
     * =============== */

    updateAccessToken() {
      // console.log('updateAccessToken');

      if (this.connectE == null
        || this.amount == null
        || this.accessTokenId == null) {
        return;
      }

      let paymentDetails = {
        amount: this.amount,
        currencyCode: this.paymentProviderPublicOptions.currencyCode,
        paymentToken: this.accessTokenId,
      };

      // console.log('updateAccessToken: connectE', paymentDetails);
      this.connectE.updateAccessToken(paymentDetails);

      if (this.wallet) {
        // console.log('updateAccessToken: wallet', paymentDetails);
        this.wallet.updateAccessToken(paymentDetails);
      }
    },

    displayErrorsCallback(errors) {
      if (errors && errors.length) {
        this.cardErrors = errors;
      } else {
        this.cardErrors = null;
      }
    },

    createAccessToken() {
      if (this.sale == null) {
        return;
      }

      let request = {
        locationId: this.location.id,
        saleId: this.sale.id,
        payDeposit: this.payingDeposit,
      };

      this.loading(true, this.$refs.paymentsenseConencteDialog);

      axios.post(this.route('api.paymentsense-connect.access-token'), request)
        .then((response) => {
          if (response.status == '201') { // HTTP_CREATED
            // pull out access token
            this.accessTokenId = response.data.accessTokenId;
            this.accessTokenExpiresAt = response.data.accessTokenExpiresAt;
            this.amount = response.data.amount;
            this.paymentExpiry = response.data.paymentExpiry;

            if (this.connectE == null) {
              this.connectE = new Connect.ConnectE(this.payConfig, this.displayErrorsCallback, this.onSubmitTriggered, this.onBlur);

              this.wallletButtonShow = true;
              this.wallet = new Connect.Wallet(this.walletPayConfig, this.displayErrorsCallback, this.walletOnPaymentExecuted);
            } else {
              this.updateAccessToken();
            }

            // enable buttons
            // this.enableCard();
            // this.cardButtonDisable = false; // handled by onBlur
            this.walletButtonDisable = false;
          } else {
            flash('Error setting up payment', 'danger');
            console.log('createAccessToken', response.data);
            console.log('createAccessToken', response.status);
            console.log('createAccessToken', response.statusText);
          }
          this.loading(false);
        })
        .catch((error) => {
          flash('Error setting up payment', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('createAccessToken: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('createAccessToken: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('createAccessToken: Error', error.message);
          }

          // this.loading(false);
        });
    },

    walletOnPaymentInitiated(event) {
      console.log('walletOnPaymentInitiated', event);

      this.cardButtonDisable = true;
      this.cardErrors = null;
      // this.disableCard();
      this.walletButtonDisable = true;
    },

    walletOnPaymentCancelled(event) {
      console.log('walletOnPaymentCancelled', event);

      flash('Payment error: ' + transactionResult.message, 'warning');

      this.cardErrors = [{message: transactionResult.message}];
      this.walletButtonDisable = false;
      this.cardButtonDisable = false;

      // need a new Access Token
      this.createAccessToken();
    },

    walletOnPaymentExecuted(transactionResult) {
      console.log('walletOnPaymentExecuted', transactionResult);
      // statusCode
      // authCode
      // message


      if (transactionResult.statusCode == 0) {
        this.paymentSuccess(transactionResult);
      } else if (transactionResult.statusCode == 99) {
        this.paymentWaiting(transactionResult);
      } else {
        flash('Payment error: ' + transactionResult.message, 'warning');

        this.cardErrors = [{message: transactionResult.message}];
        this.walletButtonDisable = false;
        this.cardButtonDisable = false;

        // need a new Access Token
        this.createAccessToken();
      }
    },

    onSubmitTriggered() {
      this.submitPayment();
    },

    onBlur(isValid) {
      this.cardButtonDisable = ! isValid;
    },

    submitPayment() {
      // card input box
      //   this.nameError = 'Card holder name is required.';
      //   return;
      // }

      if (this.timeExpired) {
        flash('Sorry you did not complete your payment in time.');
        this.cardErrors = 'Sorry you did not complete your payment in time.';

        return;
      }

      this.loading(true, this.$refs.paymentsenseConencteModal);
      this.cardButtonDisable = true;
      this.cardErrors = null;
      // this.disableCard();
      this.walletButtonDisable = true;

      // about to attempt taking monies (this will trigger 3DS)
      // TODO: hit up back end to add 2 mins and check we can still sell?

      this.connectE.executePayment()
        .then((result) => {
          // console.log('submitPayment: executePayment.then', result);
          this.loading(false);

          if (result.statusCode == 0) {
            this.paymentSuccess(result);
          } else if (result.statusCode == 99) {
            this.paymentWaiting(result);
          } else {
            flash('Payment error: ' + result.message, 'warning');

            this.cardErrors = [{message: result.message}];
            this.walletButtonDisable = false;
            this.cardButtonDisable = false;

            // need a new Access Token
            this.createAccessToken();
          }

        }).catch((result) => {
          /*handle failure here*/
          console.log('submitPayment: executePayment.catch', result);
          flash('Payment error: ' + result.message, 'warning');

          this.cardErrors = [{message: result.message}];
          this.walletButtonDisable = false;
          this.cardButtonDisable = false;
          this.loading(false);
        });
    },

    paymentSuccess(result) {
      // console.log('paymentSuccess: ', result);

      // let backend know?
      let request = {
        locationId: this.location.id,
        saleId: this.sale.id,
        accessTokenId: this.accessTokenId,
      };

      this.loading(true, this.$refs.paymentsenseConencteModal);

      axios.post(this.route('api.paymentsense-connect.payment-success'), request)
        .then((response) => {
          if (response.status == '202') { // HTTP_ACCEPTED
            // console.log('paymentSuccess: accepted');
          } else if (response.status == '204') { // HTTP_NO_CONTENT
            // console.log('paymentSuccess: confirmed');
          } else {
            flash('Error reporting payment success', 'danger');
            console.log('paymentSuccess', response.data);
            console.log('paymentSuccess', response.status);
            console.log('paymentSuccess', response.statusText);
          }

          this.loading(false);
          this.paymentSuccessConfirmed();
        })
        .catch((error) => {
          flash('Error reporting payment success', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('paymentSuccess: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('paymentSuccess: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('paymentSuccess: Error', error.message);
          }

          this.loading(false);
          this.paymentSuccessError();
        });
    },

    paymentWaiting(result) {
      // console.log('paymentWaiting: ', result);

      // let backend know?
      let request = {
        locationId: this.location.id,
        saleId: this.sale.id,
        accessTokenId: this.accessTokenId,
      };

      this.loading(true, this.$refs.paymentsenseConencteModal);

      axios.post(this.route('api.paymentsense-connect.payment-waiting'), request)
        .then((response) => {
          if (response.status == '202') { // HTTP_ACCEPTED
            // console.log('paymentSuccess: accepted');
          } else if (response.status == '204') { // HTTP_NO_CONTENT
            // console.log('paymentSuccess: confirmed');
          } else {
            flash('Error reporting payment waiting', 'danger');
            console.log('paymentSuccess', response.data);
            console.log('paymentSuccess', response.status);
            console.log('paymentSuccess', response.statusText);
          }

          this.loading(false);
          this.paymentSuccessConfirmed();
        })
        .catch((error) => {
          flash('Error reporting payment waiting', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('paymentSuccess: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('paymentSuccess: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('paymentSuccess: Error', error.message);
          }

          this.loading(false);
          this.paymentSuccessError();
        });
    },

    paymentSuccessConfirmed() {
      // refresh page
      // sale gets nulled, so need to send this to the reload page timer
      this.reloadPageTimer(Vue.util.extend({}, JSON.parse(JSON.stringify(this.sale))));

      // swap modal
      this.hidePaymentsenseConencteModal();
      $(this.$refs.successModal).modal('show');
    },

    paymentSuccessError() {
      // swap modal
      // this.hidePaymentsenseConencteModal();
      // $(this.$refs.errorModal).modal('show');
    },

    reloadPageTimer(sale) {
      if (this.reloadTime <= 0) {
        window.location.href = this.route('location.payment.success', [this.location, sale]); // redirect to .... payment success page
      } else {
        setTimeout(() => {
          this.reloadTime -= 1;
          this.reloadPageTimer(sale);
        }, 1000);
      }
    },
  },

  mounted() {
    this.$nextTick(function () {
      $(this.$refs.vueRemove).contents().unwrap();
    });

    $(this.$refs.paymentsenseConencteModal).modal('handleUpdate');
    $(this.$refs.paymentsenseConencteModal).on('hidden.bs.modal', this.paymentsenseConencteModalHidden);
    $(this.$refs.paymentsenseConencteModal).on('shown.bs.modal', this.paymentsenseConencteModalShown);
    $(this.$refs.successModal).modal('handleUpdate');

    this.$nextTick(() => {
      this.$loadScript(this.paymentProviderPublicOptions.scriptUrl)
        .then(() => {
          //
        })
        .catch(() => {
          flash('Error loading ConnectE script.', 'danger');
        });
    });

    this.currentTimeInterval = setInterval(() => {
      this.currentTime = moment(); // TODO: make as server timezone / same zone as paymentExpiry
    }, 100);
  },

  beforeDestroy() {
    clearInterval(this.currentTimeInterval);
  },
}
</script>

<style>
/*
 * PayPaymentsenseConnect.vue
 */

.card-div iframe { width: 100%; }

iframe.threeDs {
    width: 400px;
    height: 450px;
    margin: 100px 0 0 -175px;
    position: fixed;
    top: 0;
    left: 50%;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
    background-color: white;
    z-index: 9999;
}
</style>
